import _ from 'lodash';

export const isVisible = (me, myState, allowedRoles, allowedStates, doAdditionalTest, additionalTest) => {
    try {
        let myRoles = [];
        if (me) {
            myRoles = me.roleList
        }

        if (allowedRoles && allowedRoles.length > 0) {
            const rolesAllowed = _.intersection(myRoles, allowedRoles);
            if (rolesAllowed.length === 0) return false
        }
        if (allowedStates && allowedStates.length > 0) {
            const stateAllowed = allowedStates.indexOf(myState) > -1;
            if (!stateAllowed) return false;
        }
        return !(doAdditionalTest && !additionalTest);

    } catch (e) {
        console.trace(e);
        return true;
    }
};

export const isDisabled = (me, allowedRoles) => {
    try {
        let myRoles = [];
        if (me) {
            myRoles = me.roleList
        }

        if (allowedRoles && allowedRoles.length > 0) {
            const rolesAllowed = _.intersection(myRoles, allowedRoles);
            if (rolesAllowed.length !== 0) return false
        }
        return true;

    } catch (e) {
        console.trace(e);
        return true;
    }
};
